import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Loader from 'features/Loader/Loader';
import ClientHeader from './ClientHeader';
import ClientSearch from './ClientSearch';
import ClientList from './ClientList';
import HomeEmpty from '../HomeEmpty';
import './Client.scss';

class ClientsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      currentlyDisplayed: this.props.clients
    };
  }

  onClientSearch = searchTerm => {
    this.setState({
      searchTerm: searchTerm,
      currentlyDisplayed: this.props.clients.filter(client => {
        const full_name = `${client.first_name.toLocaleLowerCase()} ${client.last_name.toLocaleLowerCase()}`;
        return full_name.indexOf(searchTerm.toLocaleLowerCase()) !== -1;
      })
    });
  };

  getFilteredClients = () => {
    // filter the current list depending on the search term.
    let clients = this.props.clients.filter(client => {
      const full_name = `${client.first_name.toLocaleLowerCase()} ${client.last_name.toLocaleLowerCase()}`;
      return (
        full_name.indexOf(this.state.searchTerm.toLocaleLowerCase()) !== -1
      );
    });

    // sort the clients list alphabetically
    clients.sort((a, b) => {
      const first = `${a.first_name} ${a.last_name}`;
      const second = `${b.first_name} ${b.last_name}`;
      return first.toLocaleLowerCase() > second.toLocaleLowerCase() ? 1 : -1;
    });

    return clients;
  };

  render() {
    const currentlyDisplayedClients =
      this.props.clients.length > 0 ? this.getFilteredClients() : [];
    if (this.props.ClientsContainer) {
      return( <Loader/> );
    }
    return (
      <section className="client-side">
        <Scrollbars autoHide={true}>
          <div className="client">
            <ClientHeader label="Clients" toggle={this.props.toggle} />
            <ClientSearch setInput={this.onClientSearch} />
            <ClientList clients={currentlyDisplayedClients} />
            {this.props.clients.length > 0 ? (
              ''
            ) : (
              <HomeEmpty
                title="No clients yet"
                text="You haven’t added any new clients yet."
              />
            )}
          </div>
        </Scrollbars>
      </section>
    );
  }
}

export default ClientsContainer;
